import { render } from "./CategoryTags.vue?vue&type=template&id=2ab987f9"
import script from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-mapping-tool/components/filter/CategoryTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab987f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab987f9', __exports__)) {
    api.reload('2ab987f9', __exports__)
  }
  
  module.hot.accept("./CategoryTags.vue?vue&type=template&id=2ab987f9", () => {
    api.rerender('2ab987f9', render)
  })

}


export default __exports__